import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import type { JournalPersistIntent } from '@/utils/journalPersist';

interface JournalDraftFinalizeActionsProps {
  busy?: boolean;
  pendingIntent?: JournalPersistIntent | null;
  canFinalize: boolean;
  onSaveDraft: () => void;
  onFinalize: () => void;
  finalizeLabel?: string;
  size?: 'sm' | 'md';
}

export function JournalDraftFinalizeActions({
  busy,
  pendingIntent,
  canFinalize,
  onSaveDraft,
  onFinalize,
  finalizeLabel,
  size = 'md',
}: JournalDraftFinalizeActionsProps) {
  const { t } = useTranslation();

  return (
    <>
      <Button type="button" variant="secondary" size={size} onClick={onSaveDraft} disabled={busy}>
        {pendingIntent === 'draft' ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          t('journal.save_draft')
        )}
      </Button>
      <Button type="button" size={size} onClick={onFinalize} disabled={busy || !canFinalize}>
        {pendingIntent === 'finalize' ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          finalizeLabel ?? t('journal.finalize')
        )}
      </Button>
    </>
  );
}
